import React, { Children } from 'react';
import { useLanguage } from './LanguageContext';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { artwork } from './artwork';
export function Services() {
  const {
    t
  } = useLanguage();
  const services = [{
    image: artwork.BIRTH_PREP_ARTWORK,
    title: t.services.birthPrep.title,
    desc: t.services.birthPrep.desc,
    cta: t.services.birthPrep.cta,
    status: null,
    active: true
  }, {
    image: artwork.BREASTFEEDING_ARTWORK,
    title: t.services.breastfeeding.title,
    desc: t.services.breastfeeding.desc,
    cta: t.services.breastfeeding.cta,
    status: null,
    active: true
  }, {
    image: artwork.LACTATION_ARTWORK,
    title: t.services.lactation.title,
    desc: t.services.lactation.desc,
    cta: t.services.lactation.cta,
    status: t.services.breastfeeding.status,
    active: false
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section id="services" className="py-24 bg-teal-50/30 scroll-mt-24" data-id="element-210">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-211">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-212">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-serif font-medium text-teal-900 mb-4" data-id="element-213">
            {t.services.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-214">
            {t.services.subtitle}
          </motion.p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-3 gap-8" data-id="element-215">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className={`bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-teal-50 overflow-hidden flex flex-col group ${!service.active ? 'opacity-80' : ''}`} data-id="element-216">
              <div className="flex justify-center pt-8 relative" data-id="element-217">
                <div className="w-56 h-56 rounded-full overflow-hidden border-4 border-teal-50 shadow-md" data-id="element-218">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-219" />
                </div>
                {!service.active && service.status && <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-teal-800 text-xs font-semibold px-3 py-1.5 rounded-full shadow-sm" data-id="element-220">
                    {service.status}
                  </div>}
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-221">
                <h3 className="text-xl font-medium text-slate-800 mb-3" data-id="element-222">
                  {service.title}
                </h3>

                <p className="text-slate-600 leading-relaxed mb-8 flex-grow" data-id="element-223">
                  {service.desc}
                </p>

                {service.active ? <a href="#contact" className="inline-flex items-center text-teal-600 font-medium hover:text-teal-700 transition-colors mt-auto group/link" data-id="element-224">
                    {service.cta}
                    <ArrowRightIcon size={16} className="ml-2 transition-transform group-hover/link:translate-x-1" data-id="element-225" />
                  </a> : <span className="inline-flex items-center text-slate-400 font-medium mt-auto" data-id="element-226">
                    {service.cta}
                  </span>}
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}